import { useIntl } from 'react-intl';

function PageNotFound() {
  const intl = useIntl();

  return (<>
    {intl.formatMessage({ id: 'common.pageNotFound' })}
  </>);
}

export default PageNotFound;